module.exports = __webpack_public_path__ + "img/animation_500_knjt67yg.6feb1045.gif";